import Immutable from 'immutable';
import moment from 'moment';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';

// action creators
import { tooltipShow } from '../../../actions/tooltipActions';

// components
import { Button } from '../../shared/_form';
import ConfirmBookAppointmentModal from './_ConfirmBookAppointmentModal';
import RenderDoctors from './_RenderDoctors';
import TradeRequestModal from '../../shared/modal/TradeRequestModal';
import PremiumFeature from '../../shared/PremiumFeature';

class Appointment extends React.Component {
  static propTypes = {
    book:                 PropTypes.instanceOf(Immutable.Map),
    currentRepId:         PropTypes.string.isRequired,
    doctor:               PropTypes.instanceOf(Immutable.Map),
    doctorAvailabilities: PropTypes.instanceOf(Immutable.Map),
    id:                   PropTypes.string.isRequired,
    modals:               PropTypes.instanceOf(Immutable.Map),
    rep:                  PropTypes.instanceOf(Immutable.Map),
    scheduledOn:          PropTypes.instanceOf(moment),
    status:               PropTypes.string

  };

  render() {
    const { book, id, scheduledOn, modals, rep, officeId } = this.props;
    const isModalActive = modals && modals.getIn([this._getRequestModalId(), 'active']);

    return (
      <div className='rep-apts-index__list__container__row'>
        <div className='rep-apts-index__list__container__row__left'>
          { scheduledOn.format('h:mm A') }
        </div>
        <div className='rep-apts-index__list__container__row__center'>
          <RenderDoctors doctors={ this._getDoctors() } />
        </div>
        <div className='rep-apts-index__list__container__row__right'>
          { this._renderBookAppointmentButton() }
        </div>
        <ConfirmBookAppointmentModal appointmentId={ id }
          book={ book }
          doctors={ this._getDoctors() }
          id={ `bookAppointmentModal${scheduledOn.format()}` }
          scheduledOn={ scheduledOn } />
        { isModalActive && <TradeRequestModal id={ this._getRequestModalId() } officeId={ officeId } rep={ rep }
          requestedAppointmentId={ id }
          requestedAppointmentScheduledOn={ scheduledOn } />}
      </div>
    );
  }

  // private

  _handleShowBookModal = this._handleShowBookModal.bind(this);

  _getRequestModalId = () => {
    const { scheduledOn } = this.props;

    return `tradeRequestModal${scheduledOn.format()}`;
  };

  _getDoctors() {
    const { doctor, doctorAvailabilities, scheduledOn } = this.props;

    const availabilities = (doctorAvailabilities.get('data') || Immutable.Map()).get(scheduledOn.format('YYYY-MM-DD')) || Immutable.Map();
    const doctorData     = doctor.get('data') || Immutable.Map();
    const doctors        = [];

    availabilities.forEach((availability) => {
      doctors.push(doctorData.get(availability.get('doctor')).get('name'));
    });

    return doctors;
  }

  _handleShowBookModal() {
    const { showModal, scheduledOn } = this.props;

    showModal({ id: `bookAppointmentModal${scheduledOn.format()}` });
  }

    _handleShowDetailsModal = () => {
      const { showModal, scheduledOn } = this.props;

      showModal({ id: `bookAppointmentDetailsModal${scheduledOn.format()}` });
    };

    _handleShowTradeRequestModal = () => {
      const { showModal } = this.props;

      showModal({ id: this._getRequestModalId() });
    };

    _renderBookAppointmentButton() {
      const { status, rep, currentRepId } = this.props;
      let element;

      if (status === 'booked' || status === 'confirmed') {
        element = (
          <PremiumFeature premiumComponent={ <div className={ 'premium__rep-buttons' }>
            <Button className='premium__rep-details-button'>{this._renderRepInfo()}</Button>
            { currentRepId !== rep.get('id') &&  <Button className='premium__rep-trade-button' onClick={ this._handleShowTradeRequestModal }>Trade request</Button> }
          </div> }
            regularComponent={ <Button className='form__button--purple rep-apts-index__list__button' disabled={ true }>Taken</Button> } />
        );
      } else {
        element = (
          <Button className='form__button--green rep-apts-index__list__button' onClick={ this._handleShowBookModal }>Book</Button>
        );
      }

      return element;
    }
    _renderRepInfo() {
      const { rep } = this.props;

      if (rep.size === 0) {
        return 'no info';
      }

      const splittedName = rep.get('name').split(' ');
      const notEmptyNames = splittedName.filter((element) => element !== '');
      const name = notEmptyNames[notEmptyNames.length - 1] || '';
      const company = rep.get('company') || '';

      return (<React.Fragment><div className={ 'premium__text--name' }>{name}</div><div className={ 'premium__text--company' }>{company}</div></React.Fragment>);
    }

    _renderDoctors() {
      const doctors = this._getDoctors();

      if (doctors.length === 0) {
        doctors.push('No doctors listed');
      }

      return doctors.join(', ');
    }
}

const mapStateToProps = (state) => {
  return {
    doctor: state.get('doctor'),
    currentRepId: state.getIn(['currentUser', 'data', 'id'], ''),
    doctorAvailabilities: state.get('doctorAvailabilities'),
    modals: state.getIn(['tooltip', 'data'])
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    showModal: ({ id }) => dispatch(tooltipShow({ id }))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Appointment);



// WEBPACK FOOTER //
// ./app/components/reps/appointments/_Appointment.jsx